import React, { lazy } from 'react';
import { Wrench, CheckCircle2, Printer, FileCheck, Hammer, ClipboardList } from 'lucide-react';
import { FadeIn } from './FadeIn';
type Tool = {
  number: string;
  title: string;
  desc: string;
  src: string;
  alt: string;
};
const HERO_IMAGE_URL = 'https://cdn.magicpatterns.com/uploads/7BkzCbELLsUwyvco8cmoUC/Texto_del_parrafo.webp';
const tools: Tool[] = [{
  number: '1',
  title: 'CALCULADORA DE DESCUENTOS DE CRISTAL',
  desc: 'Fórmulas listas para usar para sistemas corredizos, batientes y paños fijos. Metés el vano y obtenés el cristal exacto. Cero errores de medición.',
  src: HERO_IMAGE_URL,
  alt: 'Calculadora de descuentos de cristal para mamparas'
}, {
  number: '2',
  title: 'PLANILLA DE RELEVAMIENTO EN OBRA',
  desc: 'Protocolo completo de medición en 3 puntos. Plomo, escuadra, vanos críticos y datos del cliente. Todo organizado en una hoja A4 lista para llevar.',
  src: HERO_IMAGE_URL,
  alt: 'Planilla de relevamiento en obra para mamparas'
}, {
  number: '3',
  title: 'CALCULADORA DE PRESUPUESTO COMPLETO',
  desc: 'Los 6 componentes del costo real, fórmula del precio con margen garantizado y scripts para defender tu precio. Cobrá lo que tu trabajo vale.',
  src: HERO_IMAGE_URL,
  alt: 'Calculadora de presupuesto profesional para mamparas'
}];
const features = [{
  icon: Printer,
  label: 'Herramientas imprimibles'
}, {
  icon: FileCheck,
  label: 'Fórmulas listas para usar'
}, {
  icon: ClipboardList,
  label: 'Protocolos de taller'
}, {
  icon: Hammer,
  label: 'Material para uso real en obra'
}];
export function ToolsIncluded() {
  return <section className="py-16 md:py-20 bg-surface border-y border-white/5" aria-label="Herramientas reales incluidas en el sistema" data-id="element-486">
      <div className="container mx-auto px-4 max-w-6xl" data-id="element-487">
        <FadeIn data-id="element-488">
          <div className="text-center mb-12" data-id="element-489">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 mb-4 rounded-full border border-gold/40 bg-gold/10" data-id="element-490">
              <Wrench className="w-3.5 h-3.5 text-gold" aria-hidden="true" data-id="element-491" />
              <span className="text-gold text-xs font-semibold uppercase tracking-wider" data-id="element-492">
                Herramientas operativas
              </span>
            </div>
            <h2 className="text-3xl md:text-5xl font-bold text-white mb-4 leading-tight" data-id="element-493">
              🔧 HERRAMIENTAS REALES INCLUIDAS{' '}
              <span className="text-gold" data-id="element-494">EN EL SISTEMA</span>
            </h2>
            <p className="text-gray-400 max-w-3xl mx-auto text-base md:text-lg leading-relaxed" data-id="element-495">
              Estas son algunas de las planillas y herramientas operativas
              incluidas dentro del sistema. Diseñadas para trabajar con{' '}
              <span className="text-white font-medium" data-id="element-496">menos errores</span>,{' '}
              <span className="text-white font-medium" data-id="element-497">menos desperdicio</span>{' '}
              y <span className="text-white font-medium" data-id="element-498">más precisión</span> en
              el taller y en la obra.
            </p>
          </div>
        </FadeIn>

        <div className="space-y-10 md:space-y-14 mb-12" data-id="element-499">
          {tools.map((tool, i) => <FadeIn key={tool.number} delay={i * 0.1} data-id="element-500">
              <article className="bg-background rounded-3xl border border-white/10 overflow-hidden hover:border-gold/30 transition-colors group" data-id="element-501">
                <div className="relative bg-navy-dark p-3 md:p-5 border-b border-white/5" data-id="element-502">
                  <div className="absolute top-5 left-5 z-10 flex items-center gap-2" data-id="element-503">
                    <span className="inline-flex items-center justify-center w-9 h-9 md:w-11 md:h-11 rounded-xl bg-gold text-background font-bold text-base md:text-lg shadow-lg shadow-gold/30" data-id="element-504">
                      {tool.number}
                    </span>
                    <span className="hidden sm:inline-block text-[10px] font-bold text-gold uppercase tracking-widest border border-gold/40 bg-background/80 backdrop-blur px-2.5 py-1 rounded-md" data-id="element-505">
                      Preview real
                    </span>
                  </div>
                  <img src={tool.src} alt={tool.alt} loading="lazy" decoding="async" className="w-full h-auto rounded-xl shadow-2xl shadow-black/40 group-hover:scale-[1.01] transition-transform duration-500 ease-out max-h-[400px] object-contain mx-auto" data-id="element-506" />
                </div>

                <div className="p-6 md:p-8" data-id="element-507">
                  <div className="flex items-start gap-3 mb-3" data-id="element-508">
                    <h3 className="text-xl md:text-2xl font-bold text-white leading-tight" data-id="element-509">
                      {tool.title}
                    </h3>
                  </div>
                  <p className="text-gray-400 text-base leading-relaxed" data-id="element-510">
                    {tool.desc}
                  </p>
                </div>
              </article>
            </FadeIn>)}
        </div>

        <FadeIn delay={0.2} data-id="element-511">
          <div className="relative bg-background rounded-3xl border border-gold/20 p-6 md:p-10 overflow-hidden" data-id="element-512">
            <div className="absolute inset-0 pointer-events-none opacity-50" aria-hidden="true" style={{
            background: 'radial-gradient(circle at 0% 0%, rgba(245,200,66,0.08) 0%, transparent 50%), radial-gradient(circle at 100% 100%, rgba(245,200,66,0.08) 0%, transparent 50%)'
          }} data-id="element-513" />
            <div className="relative z-10" data-id="element-514">
              <p className="text-center text-xs md:text-sm font-bold text-gold uppercase tracking-widest mb-6" data-id="element-515">
                Todo el sistema incluye
              </p>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6" data-id="element-516">
                {features.map((f, i) => <div key={i} className="flex items-center gap-3 bg-surface/50 border border-white/5 rounded-xl p-4" data-id="element-517">
                    <div className="shrink-0 w-10 h-10 rounded-lg bg-gold/10 border border-gold/30 flex items-center justify-center" data-id="element-518">
                      <CheckCircle2 className="w-5 h-5 text-gold" aria-hidden="true" data-id="element-519" />
                    </div>
                    <span className="text-white text-sm md:text-base font-medium leading-tight" data-id="element-520">
                      {f.label}
                    </span>
                  </div>)}
              </div>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}